import { Checkbox, Typography } from '@weareopenr/component-library';
import styles from './ChecboxList.module.scss';
import { UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { Fragment } from 'react';

interface ICheckboxListProps {
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  watch: UseFormWatch<any>;
  checkboxes: ICheckbox[];
  // where in react hook form will you store the checkbox related state
  // 'storagePrefix' : {'a checkbox id': boolean}
  storagePrefix?: string;
}

interface ICheckbox {
  id: string;
  label: string;
  description?: string;
}

const getStorageLocation = (id: string, storagePrefix?: string): string => {
  if (storagePrefix) {
    return `${storagePrefix}.${id}`;
  }
  return id;
};
export const CheckboxList = ({ register, setValue, storagePrefix, checkboxes, watch }: ICheckboxListProps) => {
  const selected = storagePrefix ? watch(storagePrefix) : watch();

  return (
    <div>
      <Checkbox
        label="Select all"
        onChange={() => {
          const values = Object.values(selected);
          const noneSelected = !values.includes(true);
          const someSelected = values.includes(true) && values.includes(false);
          if (noneSelected || someSelected) {
            checkboxes.map((box) => setValue(getStorageLocation(box.id, storagePrefix), true, { shouldDirty: true }));
          } else {
            checkboxes.map((box) => setValue(getStorageLocation(box.id, storagePrefix), false, { shouldDirty: true }));
          }
        }}
        indeterminate={Object.values(selected).includes(true) && Object.values(selected).includes(false)}
        checked={Object.values(selected).includes(true)}
        name="all"
        labelWeight="regular"
      />
      <div className={styles['indent']}>
        {checkboxes.map((box) => (
          <Fragment key={box.id}>
            <Checkbox
              labelWeight="regular"
              label={box.label}
              register={register}
              name={getStorageLocation(box.id, storagePrefix)}
            />
            {box.description && <Typography className={styles['description']}>{box.description}</Typography>}
          </Fragment>
        ))}
      </div>
    </div>
  );
};
